var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPoint = function SvgPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10282_14488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.14 0 0 3.14 0 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm.455 11.153c-.332.056-.994.194-1.33.222-.284.024-.553-.14-.716-.373a.875.875 0 0 1-.106-.801l1.323-3.638H5.25c-.001-.759.567-1.316 1.295-1.53.347-.102.994-.242 1.33-.22.202.012.553.139.716.373a.875.875 0 0 1 .106.8L7.374 9.626H8.75c0 .757-.548 1.404-1.295 1.528zm.42-6.778a.875.875 0 1 1 0-1.75.875.875 0 0 1 0 1.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10282_14488"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgPoint;